<input
  [formControl]="formControl"
  [formlyAttributes]="field"
  [attr.placeholder]="props.placeholder || ''"
  [attr.data-id]="field.dataId"
  autocomplete="off"
  class="text-input"
/>
